import { NavigationMenuVisibilityContext } from '../../components/NavigationPanel/NavigationMenuVisibilityContext';
import { useContext } from 'react';
import { useFocusEffect } from 'expo-router';



export const useHideNavigationMenu = () => {
  const {setVisible} = useContext(NavigationMenuVisibilityContext);
  useFocusEffect(() => {
    setVisible(false);
    return () => {
      setVisible(true);
    };
  });
};